import { ServiceTypes } from 'constants/ServiceTypes';
import React from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { FieldCalibrationStore, MAX_CALIBRATION_COUNT_NUMBER, MAX_HOME_PLATE_COUNT_NUMBER } from 'stores/FieldCalibrationStore';
import {
  Count,
  CountFlex,
  CountWrapper,
  Flex,
  Label,
  MaxCount,
  PitchCount,
  ProgressBarWrapper,
  Wrapper,
} from './styles/ProgressBarContainerStyles';

const ProgressBarContainer: React.FC = () => {
  const fieldCalibrationStore = useInjection<FieldCalibrationStore>(ServiceTypes.FieldCalibrationStore);

  return (
    <ProgressBarWrapper>
      <Flex>
        <PitchCount>Pitch count</PitchCount>
        <CountFlex>
          <Wrapper>
            <Label>Landing area</Label>
            <CountWrapper>
              <Count>{fieldCalibrationStore.bounceWithin5FeetFromHPCount}</Count>
              <MaxCount>/{MAX_CALIBRATION_COUNT_NUMBER}</MaxCount>
            </CountWrapper>
          </Wrapper>
          <Wrapper>
            <Label>Home plate</Label>
            <CountWrapper>
              <Count>{fieldCalibrationStore.hitHPCount}</Count>
              <MaxCount>/{MAX_HOME_PLATE_COUNT_NUMBER}</MaxCount>
            </CountWrapper>
          </Wrapper>
          <Wrapper>
            <Label>Total</Label>
            <Count>{fieldCalibrationStore.totalCount}</Count>
          </Wrapper>

          <Wrapper></Wrapper>
        </CountFlex>
      </Flex>
    </ProgressBarWrapper>
  );
};

export default ProgressBarContainer;
